import config from "../../config.json";
import { reportApiError } from "../errors/presentError";
const BASE_AUTH_API = config.BASE_AUTH_API;

export const fetchCampainAPI = async (token) => {
    let responseData;
    try {
        await fetch(`${BASE_AUTH_API}campain`, {
            method: 'GET',
            headers: {
                Accept: 'application/form-data',
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        }).then((response) => response.json()).then((data) => responseData = data);

        if (responseData.success) {
            return responseData.campains
        }
        else {
            return
        }
    } catch (error) {
        reportApiError(error)
        return
    }
}
export const addCampainAPI = async (token, data) => {
    let responseData;
    try {
        await fetch(`${BASE_AUTH_API}campain`, {
            method: 'POST',
            headers: {
                Accept: 'application/form-data',
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        }).then((response) => response.json()).then((data) => responseData = data);
        if (responseData.success) {
            return responseData.campain
        }
        else {
            return
        }
    } catch (error) {
        reportApiError(error)
        return
    }
}

export const updateCampainAPI = async (token, id, data) => {
    let responseData;
    try {
        await fetch(`${BASE_AUTH_API}campain/${id}`, {
            method: 'PATCH',
            headers: {
                Accept: 'application/form-data',
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        }).then((response) => response.json()).then((data) => responseData = data);
        if (responseData.success) {
            return responseData.updated
        }
        else {
            return
        }
    } catch (error) {
        reportApiError(error)
        return
    }
}